<template>
  <div class="box box-default">
    <div class="box-header with-border">
      <h3 class="box-title">{{ boxheading }}</h3>
    </div>
    <div class="box-body">
      <slot></slot>
    </div>
    <!-- /.box-body -->
  </div>
</template>

<script>
export default {
  name: "Box",
  props: ["boxheading"],
};
</script>

<style lang="scss" scoped></style>
